<template>
    <section v-cloak>
        <div class="container">
            <template v-if="hasPermission">
                <header class="flex justify-between items-center">
                    <div>
                        <h2 class="font-medium text-md mb-0 mobile:text-base">{{translate('bedrijfsstructuur')}}</h2>
                    </div>
                    <div>
<!--                        <div class="flex gap-3 items-center">-->
<!--                            <div class="toggle">-->
<!--                                <a href="" :class="{'active': view == View.LIST_TREE}"-->
<!--                                   v-on:click.prevent="view = View.LIST_TREE">-->
<!--                                    <i class="far fa-list-tree mr-2 mobile:mr-0"></i><span class="mobile:hidden">Lijst</span>-->
<!--                                </a>-->
<!--                                <a href="" :class="{'active': view == View.GRAPH}"-->
<!--                                   v-on:click.prevent="view = View.GRAPH">-->
<!--                                    <i class="far fa-diagram-project mr-2 mobile:mr-0"></i><span class="mobile:hidden">Diagram</span>-->
<!--                                </a>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </header>
                
                <main class="mt-6" v-if="model">
                    <div v-if="model.childParticipations.length === 0 && model.parentParticipations.length === 0">
                        <p>
                            {{translate('no_results')}}
                        </p>
                    </div>
                    <div v-else >
                        <ParticipationList :is="view"
                                   :child-participations="model.childParticipations" 
                                   :parent-participations="model.parentParticipations" 
                                   :vat="detailStore.vat" 
                                   :local-id="detailStore.localId" 
                                   :naam="detailStore.naamOfAfkorting"
                                   :vorm="detailStore.vorm"
                                   :barometer="detailStore.barometer"></ParticipationList>
                    </div>
                </main>
             
            </template>
            <no-access v-else :sub-page="detailStore.SubPage.PARTICIPATIONS"></no-access>
        </div>
       

    </section>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useDetailStore} from "../store";
import NoAccess from "./no-access.vue";

import ParticipationGraph from "./participations/graph/graph.vue";
import ParticipationList from "./participations/list/list.vue";
import {StructureModel, SubPage} from "../types";
import {Feature} from "../../../types/dto/Feature";

enum View {
    LIST_TREE = "ParticipationList",
    GRAPH = "ParticipationGraph"
}

export default defineComponent({
    name: "participations",
    components: {
        NoAccess,
        ParticipationList
    },
    data() {
        return {
            Feature,
            detailStore: useDetailStore(),
            View,
            view: View.LIST_TREE as View
        }
    },
    computed: {
        hasPermission(): boolean {
            return this.detailStore.canSeePaidComponents;
        },
        model(): StructureModel | null {
            return this.detailStore.pageModel[SubPage.PARTICIPATIONS];
        },
    }
});
</script>